export default __webpack_public_path__ + "static/media/Eye_5_F_C2.124b2d5e.svg";